module.exports = __webpack_public_path__ + "img/image-upload-icon.e6239160.svg";